import { useEffect, useState } from "react";
import { getCompanyCountApi } from "../../../services/super-admin-service/_dashboard";

const SuperAdminDashboard = () => {
  const [companyCount, setCompanyCount] = useState(0);
  const getInitialData = async () => {
    const result: any = await getCompanyCountApi();
    if (result.isSuccess) {
      setCompanyCount(result.data);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <>
      <div className="row g-4 mt-1">
        <div className="row g-4 mt-1">
          <div className="col-lg-2 col-md-4 col-sm-6 col-12">
            <div className="card card-border-shadow-primary h-100">
              <div className="card-body py-4">
                <div className="d-flex align-items-center mb-2">
                  <div className="avatar me-4">
                    <span className="avatar-initial rounded bg-label-primary">
                      <i
                        className="fa-solid fa-building"
                        style={{ fontSize: "24px" }}
                      ></i>
                    </span>
                  </div>
                  <h4 className="mb-0">{companyCount}</h4>
                </div>
                <p className="mb-1">Total Company</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperAdminDashboard;
